import React from 'react';
import { Box, keyframes, Modal, ModalOverlay } from '@chakra-ui/react';
import { ligaFBeat1, ligaFBeat2, ligaFBeat3, ligaFBeat4, ligaFBeat5, ligaFBeat6, ligaFBeat7, ligaFBeat8, ligaFBeat9, ligaFBeat10, laLigaSpinner } from '@laliga-cdac2/assets';
import { keyframes as keyframes$1 } from '@emotion/react';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject;

var breatheAnimation = /*#__PURE__*/keyframes(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n 10% { background-image: url(", "); }\n 20% { background-image: url(", "); }\n 30% { background-image: url(", "); }\n 40% { background-image: url(", "); }\n 50% { background-image: url(", "); }\n 60% { background-image: url(", "); }\n 70% { background-image: url(", "); }\n 80% { background-image: url(", "); }\n 90% { background-image: url(", "); }\n 100% { background-image: url(", "); }\n"])), ligaFBeat1, ligaFBeat2, ligaFBeat3, ligaFBeat4, ligaFBeat5, ligaFBeat6, ligaFBeat7, ligaFBeat8, ligaFBeat9, ligaFBeat10);

var LigaFBeatSpinner = function LigaFBeatSpinner() {
  return React.createElement(Box, {
    __css: {
      position: 'fixed',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: '175px',
      height: '113px',
      zIndex: 'popover',
      animation: breatheAnimation + " 1.8s steps(12) 0s infinite",
      backgroundSize: 'cover'
    }
  });
};

var _templateObject$1;

var breatheAnimation$1 = /*#__PURE__*/keyframes$1(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n 0% { background-position: 0px 0px; }\n  100% { background-position: 0px -27644px; }\n "])));
var MOBILE = '@media(max-width: 420px)';

var MinimalBeatSpinner = function MinimalBeatSpinner() {
  var _sx;

  return React.createElement(Box, {
    __css: {
      position: 'fixed',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%) scale(0.3)',
      width: '919px',
      height: '165px',
      animation: breatheAnimation$1 + " 5.45s steps(129) 0s infinite",
      background: "url(" + laLigaSpinner + ")",
      zIndex: 'popover',
      backgroundSize: 'cover'
    },
    sx: (_sx = {}, _sx[MOBILE] = {
      transform: 'translate(-50%, -50%) scale(0.3)'
    }, _sx)
  });
};

var VariantEnum;

(function (VariantEnum) {
  VariantEnum[VariantEnum["defaultVariant"] = 0] = "defaultVariant";
  VariantEnum[VariantEnum["ligaFVariant"] = 1] = "ligaFVariant";
})(VariantEnum || (VariantEnum = {}));

var BeatSpinner = function BeatSpinner(props) {
  var isOpen = props.isOpen,
      variant = props.variant;
  var SPINNER = {
    defaultVariant: React.createElement(MinimalBeatSpinner, null),
    ligaFVariant: React.createElement(LigaFBeatSpinner, null)
  };
  return React.createElement(Modal, {
    isOpen: isOpen,
    onClose: function onClose() {
      return null;
    }
  }, React.createElement(ModalOverlay, null), SPINNER[variant || 'defaultVariant']);
};

export default BeatSpinner;